import { facebook, formatters } from '@itau-loans-www/utils'

import auth from './auth'
import { defaultLeadsApiCall } from './utils'

const getMaritalStatuses = async () => {
  const { data } = await auth({}).then((_http) =>
    _http.get(`v2/itau-loans-api/marital-statuses/`)
  )

  return data
}

const getStates = async () => {
  const { data } = await auth({}).then((_http) =>
    _http.get(`v2/itau-loans-api/states/`)
  )

  return data
}

const getOccupations = async () => {
  const { data } = await auth({}).then((_http) =>
    _http.get(`v2/itau-loans-api/occupations/`)
  )

  return data
}

const putPersonalData = async (requestBody) => {
  const { data } = await defaultLeadsApiCall({
    endpoint: 'personal-data',
    method: 'put',
    body: requestBody
  })

  return data
}

const getPersonalData = async (requestBody) => {
  const { data } = await defaultLeadsApiCall({
    endpoint: 'personal-data',
    method: 'get',
    body: requestBody
  })

  return data
}

const getLeadDocument = async () => {
  const { data } = await defaultLeadsApiCall({
    endpoint: 'document',
    method: 'get'
  })

  return data
}

const putLeadDocument = async (requestBody) => {
  const formatedBody = {
    document_type: requestBody.document_type,
    document_number: requestBody.document_number,
    document_issuer: requestBody.document_issuer,
    document_issuer_id: requestBody.document_issuer_id,
    document_issue_date: formatters.date.toISO(requestBody.document_issue_date),
    document_state: requestBody.document_state,
    document_state_id: requestBody.document_state_id
  }

  const { data } = await defaultLeadsApiCall({
    endpoint: 'document',
    method: 'put',
    body: formatedBody
  })

  return data
}

const putLeadAddress = async (requestBody, type) => {
  const formatedBody = {
    city: requestBody.city,
    complement: requestBody.complement,
    neighborhood: requestBody.neighborhood,
    number: requestBody.number,
    state: requestBody.state.toUpperCase(),
    street: requestBody.street,
    zip_code: requestBody.zip_code.replace(/[^0-9]/g, '')
  }

  const { data } = await defaultLeadsApiCall({
    endpoint: `address/${type}`,
    method: 'put',
    body: formatedBody
  })

  return data
}

const getLeadAddress = async (type) => {
  const { data } = await defaultLeadsApiCall({
    endpoint: `address/${type}`,
    method: 'get'
  })

  return data
}

const getIdentityAgencies = async () => {
  const { data } = await auth({}).then((_http) =>
    _http.get(`v2/itau-loans-api/identity-agencies/`)
  )

  return data
}

const putLeadBankingData = async (requestBody, productCode) => {
  const formatedBody = {
    account_digit: requestBody.account_digit,
    account_number: requestBody.account_number,
    bank_code: requestBody.bank_code,
    branch: requestBody.branch,
    main_account: requestBody.main_account
  }

  const { data } = await defaultLeadsApiCall({
    endpoint: `banking`,
    method: 'put',
    body: formatedBody
  })

  facebook.trackLeadComplete(productCode)

  return data
}

const getLeadBankingData = async () => {
  const { data } = await defaultLeadsApiCall({
    endpoint: `banking`,
    method: 'get'
  })

  return data
}

export default {
  getMaritalStatuses,
  getStates,
  putPersonalData,
  getLeadDocument,
  putLeadDocument,
  putLeadAddress,
  getIdentityAgencies,
  putLeadBankingData,
  getLeadAddress,
  getLeadBankingData,
  getOccupations,
  getPersonalData
}
